import { motion } from "framer-motion";
import { Phone } from "lucide-react";

const EmergencyButton = () => (
  <motion.a
    href="tel:+491714312224"
    data-testid="emergency-button"
    className="fixed bottom-20 right-6 z-50 flex items-center gap-3 bg-[#3E4C59] text-white px-4 py-3 shadow-xl font-manrope cursor-pointer"
    style={{ borderRadius: "2px" }}
    animate={{
      boxShadow: [
        "0 0 0 0 rgba(62, 76, 89, 0.5)",
        "0 0 0 14px rgba(62, 76, 89, 0)",
        "0 0 0 0 rgba(62, 76, 89, 0)",
      ],
    }}
    transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
    whileHover={{ scale: 1.04 }}
    whileTap={{ scale: 0.97 }}
  >
    <div className="w-8 h-8 rounded-full bg-white/15 flex items-center justify-center shrink-0">
      <Phone size={15} className="text-[#C9A66B]" />
    </div>
    <div>
      <div className="text-[10px] uppercase tracking-widest text-white/60 leading-none mb-0.5">
        24/7 Trauerfall
      </div>
      <div className="font-semibold text-sm leading-none tracking-wide">0171 4312224</div>
    </div>
  </motion.a>
);

export default EmergencyButton;
